import { createFileRoute } from '@tanstack/react-router';

import { MarketplacePage } from '@/features/marketplace/marketplace-page';

export const Route = createFileRoute('/_app/marketplace/')({ component: MarketplacePage });
